import React from 'react'

export default function Portfolio() {
  return (

    <section id="portfolio" className="portfolio">
      <div className="container">

        <div className="section-title">
          <h2>Portfolio</h2>
          <p>My Works</p>
        </div>

        <div className="row">
          <div className="col-lg-12 d-flex justify-content-center">
            <ul id="portfolio-flters">
              <li data-filter="*" className="filter-active">All</li>
              <li data-filter=".filter-app">Web</li>
              <li data-filter=".filter-card">Mobile</li>
              <li data-filter=".filter-web">Cloud</li>
            </ul>
          </div>
        </div>

        <div className="row portfolio-container">

          <div className="col-lg-4 col-md-6 portfolio-item filter-app">
            <div className="portfolio-wrap">
              <img src="assets/img/portfolio/LeadTech.png" className="img-fluid" alt="" />
              <div className="portfolio-info">
                <h4>LeadTech</h4>
                <p>Web</p>
                <div className="portfolio-links">
                  <a href="assets/img/portfolio/LeadTech.png" data-gallery="portfolioGallery" className="portfolio-lightbox"
                    title="LeadTech"><i className="bx bx-plus"></i></a>
                  <a href="https://musing-bhabha-c32fb6.netlify.app/" data-gallery="portfolioDetailsGallery"
                    data-glightbox="type: external" className="portfolio-details-lightbox" title="LeadTech"><i
                      className="bx bx-link"></i></a>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- <div className="col-lg-4 col-md-6 portfolio-item filter-web">
          <div className="portfolio-wrap">
            <img src="assets/img/portfolio/portfolio-2.jpg" className="img-fluid" alt="">
            <div className="portfolio-info">
              <h4>Web 3</h4>
              <p>Web</p>
              <div className="portfolio-links">
                <a href="assets/img/portfolio/portfolio-2.jpg" data-gallery="portfolioGallery"
                  className="portfolio-lightbox" title="Web 3"><i className="bx bx-plus"></i></a>
                <a href="portfolio-details.html" data-gallery="portfolioDetailsGallery" data-glightbox="type: external"
                  className="portfolio-details-lightbox" title="Portfolio Details"><i className="bx bx-link"></i></a>
              </div>
            </div>
          </div>
        </div> --> */}

          <div className="col-lg-4 col-md-6 portfolio-item filter-app">
            <div className="portfolio-wrap">
              <img src="assets/img/portfolio/StreamsFoundation.png" className="img-fluid" alt="" />
              <div className="portfolio-info">
                <h4>Streams Foundation</h4>
                <p>Web</p>
                <div className="portfolio-links">
                  <a href="assets/img/portfolio/StreamsFoundation.png" data-gallery="portfolioGallery" className="portfolio-lightbox"
                    title="Streams Foundation"><i className="bx bx-plus"></i></a>
                  <a href="https://streamsfoundation.org" data-gallery="portfolioDetailsGallery"
                    data-glightbox="type: external" className="portfolio-details-lightbox" title="Streams Foundation"><i
                      className="bx bx-link"></i></a>
                </div>
              </div>
            </div>
          </div>


          <div className="col-lg-4 col-md-6 portfolio-item filter-app">
            <div className="portfolio-wrap">
              <img src="assets/img/portfolio/PaltonMorgan.png" className="img-fluid" alt="" />
              <div className="portfolio-info">
                <h4>Palton Morgan</h4>
                <p>Web</p>
                <div className="portfolio-links">
                  <a href="assets/img/portfolio/PaltonMorgan.png" data-gallery="portfolioGallery"
                    className="portfolio-lightbox" title="Palton Morgan"><i className="bx bx-plus"></i></a>
                  <a href="https://amazing-kirch-ec1408.netlify.app" data-gallery="portfolioDetailsGallery"
                    data-glightbox="type: external" className="portfolio-details-lightbox" title="Palton Morgan"><i
                      className="bx bx-link"></i></a>
                </div>
              </div>
            </div>
          </div>


          <div className="col-lg-4 col-md-6 portfolio-item filter-card">
            <div className="portfolio-wrap">
              <img src="assets/img/portfolio/StransactOffice.png" className="img-fluid" alt="" />
              <div className="portfolio-info">
                <h4>Stransact Office</h4>
                <p>Mobile</p>
                <div className="portfolio-links">
                  <a href="assets/img/portfolio/StransactOffice.png" data-gallery="portfolioGallery"
                    className="portfolio-lightbox" title="Stransact Office"><i className="bx bx-plus"></i></a>
                  <a href="https://play.google.com/store/apps/details?id=com.ipaysuite"
                    data-gallery="portfolioDetailsGallery" data-glightbox="type: external"
                    className="portfolio-details-lightbox" title="Stransact Office"><i className="bx bx-link"></i></a>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="col-lg-4 col-md-6 portfolio-item filter-web">
          <div className="portfolio-wrap">
            <img src="assets/img/portfolio/portfolio-5.jpg" className="img-fluid" alt="">
            <div className="portfolio-info">
              <h4>Web 2</h4>
              <p>Web</p>
              <div className="portfolio-links">
                <a href="assets/img/portfolio/portfolio-5.jpg" data-gallery="portfolioGallery"
                  className="portfolio-lightbox" title="Web 2"><i className="bx bx-plus"></i></a>
                <a href="portfolio-details.html" data-gallery="portfolioDetailsGallery" data-glightbox="type: external"
                  className="portfolio-details-lightbox" title="Portfolio Details"><i className="bx bx-link"></i></a>
              </div>
            </div>
          </div>
        </div>  */}



          {/* <div className="col-lg-4 col-md-6 portfolio-item filter-card">
          <div className="portfolio-wrap">
            <img src="assets/img/portfolio/portfolio-7.jpg" className="img-fluid" alt="">
            <div className="portfolio-info">
              <h4>Card 1</h4>
              <p>Card</p>
              <div className="portfolio-links">
                <a href="assets/img/portfolio/portfolio-7.jpg" data-gallery="portfolioGallery"
                  className="portfolio-lightbox" title="Card 1"><i className="bx bx-plus"></i></a>
                <a href="portfolio-details.html" data-gallery="portfolioDetailsGallery" data-glightbox="type: external"
                  className="portfolio-details-lightbox" title="Portfolio Details"><i className="bx bx-link"></i></a>
              </div>
            </div>
          </div>
        </div>  */}

          {/* <!-- <div className="col-lg-4 col-md-6 portfolio-item filter-card">
          <div className="portfolio-wrap">
            <img src="assets/img/portfolio/portfolio-8.jpg" className="img-fluid" alt="">
            <div className="portfolio-info">
              <h4>Card 3</h4>
              <p>Card</p>
              <div className="portfolio-links">
                <a href="assets/img/portfolio/portfolio-8.jpg" data-gallery="portfolioGallery"
                  className="portfolio-lightbox" title="Card 3"><i className="bx bx-plus"></i></a>
                <a href="portfolio-details.html" data-gallery="portfolioDetailsGallery" data-glightbox="type: external"
                  className="portfolio-details-lightbox" title="Portfolio Details"><i className="bx bx-link"></i></a>
              </div>
            </div>
          </div>
        </div> --> */}

          {/* <!-- <div className="col-lg-4 col-md-6 portfolio-item filter-web">
          <div className="portfolio-wrap">
            <img src="assets/img/portfolio/portfolio-9.jpg" className="img-fluid" alt="">
            <div className="portfolio-info">
              <h4>Web 3</h4>
              <p>Web</p>
              <div className="portfolio-links">
                <a href="assets/img/portfolio/portfolio-9.jpg" data-gallery="portfolioGallery"
                  className="portfolio-lightbox" title="Web 3"><i className="bx bx-plus"></i></a>
                <a href="portfolio-details.html" data-gallery="portfolioDetailsGallery" data-glightbox="type: external"
                  className="portfolio-details-lightbox" title="Portfolio Details"><i className="bx bx-link"></i></a>
              </div>
            </div>
          </div>
        </div> --> */}

        </div>

      </div>
    </section>
  )
}
